!function(e,r){"object"==typeof exports&&"undefined"!=typeof module?module.exports=r():"function"==typeof define&&define.amd||(e.classcat=r())}(this,function(){"use strict";return function e(r){var t="",n=typeof r;if("string"===n||"number"===n)return r||"";if(Array.isArray(r)&&r.length>0)for(var o=0,f=r.length;o<f;o++){var i=e(r[o]);i&&(t+=(t&&" ")+i)}else for(var u in r)r.hasOwnProperty(u)&&r[u]&&(t+=(t&&" ")+u);return t}});
//# sourceMappingURL=classcat.js.map


//////////////////
// WEBPACK FOOTER
// ./~/classcat/dist/classcat.js
// module id = 10
// module chunks = 168707334958949